<div class="type">
    <i class="fa" [ngClass]="resolveMaterialTypeIcon()"></i>
    <span>{{ ('admin.strain.materials.types.' + resolveMaterialTypeKey()) | translate }}</span>
</div>
<div class="material">{{ item?.material?.name || 'Unassigned material' }}</div>
<app-input
    class="code"
    label="Code"
    placeholder="Scan or enter code"
    [formControl]="form?.get('code')"
    [showErrors]="form?.get('code')?.touched && form?.get('code')?.invalid"
    [isDisabled]="!canEdit || !canEditCode">
</app-input>
